import { Controller } from '@hotwired/stimulus'

// Artist Distances Controller
//
// Fills in each artist's distance to the landing page's city, in the empty
// span the card renders after its homecity.
//
// Setting textContent is idempotent, so this is safe to run again on Turbo
// cache restore or Vite HMR. Artists with no note keep an empty span, which
// _artist_card.sass hides.
export default class extends Controller {
  static targets = ['distance']

  static values = {
    // Map of artist id to distance note, eg { "1234": "34 km fra Berlin" }
    // Empty on pages without a location.
    notes: Object
  }

  connect () {
    this.distanceTargets.forEach(distance => {
      distance.textContent = this.notesValue[distance.dataset.artistId] || ''
    })
  }
}
